import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Autocomplete, Box, Grid, TextField, Typography, useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { ITheme, theme } from '../../../utils/theme';
import { IPreference } from '../TelephonePlugInData';
import { DeleteIconStyle, SelectStyle, SelectTitleStyle, TitleStyle } from './styled';

export interface IPlugInPreferencesProps {
  preferences: IPreference[];
  selectedPreferences: IPreference[];
  onSelectPreference: (
    e: React.SyntheticEvent<Element, Event>,
    val: IPreference | null, sequence: 1 | 2 | 3
  ) => void;
  onDeletePreference: (sequence: 1 | 2 | 3) => void;
  disabled?: boolean;
  isUnion: boolean;
  userPreferencesText: string;
}

export const PlugInPreferences: FC<IPlugInPreferencesProps> = ({
  preferences,
  selectedPreferences,
  onDeletePreference,
  onSelectPreference,
  disabled,
  isUnion,
  userPreferencesText
}) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const options = preferences.filter(i => !selectedPreferences.includes(i));
  return (
    <Grid container sx={(theme: ITheme) => ({ borderTop: `1px solid ${theme.palette.grey[300]}` })}>
      <Grid item xs={1} sm={2} />
      <Grid item xs={10} sm={8} sx={{ p: 0, pb: 4 }}>
        <Typography sx={TitleStyle}>Plug-In Preferences</Typography>
        {isUnion ? ['First', 'Second', 'Third'].map((item, i) => {
          const value = selectedPreferences.find(p => p.sequence === i + 1) ?? null;
          return (
            <Box key={item}>
              <Typography sx={SelectTitleStyle}>
                {item}
                {value && !disabled && <DeleteForeverIcon
                  onClick={() => onDeletePreference(i + 1 as 1 | 2 | 3)}
                  sx={DeleteIconStyle}
                />}
              </Typography>
              <Autocomplete
                clearIcon={null}
                value={value}
                onChange={(e, val) => {
                  onSelectPreference(e, val, i + 1 as 1 | 2 | 3)
                }}
                options={options}
                getOptionDisabled={(o) => !!selectedPreferences.find(p => p.code === o.code)}
                disabled={disabled}
                autoComplete
                getOptionLabel={(o) => `${o.code} - ${o.description}`}
                renderInput={(params) => <TextField
                  placeholder='Select a Preference'
                  sx={SelectStyle}
                  {...params}
                  inputProps={{
                    ...params.inputProps,
                    inputMode: isMobile ? 'numeric' : undefined,
                  }}
                />}
              />
            </Box>
          )
        }) : <Typography
          sx={{ mb: 1, color: (theme: ITheme) => theme.palette.red.A700, fontWeight: 'bold', textAlign: 'center' }}
        >
          {userPreferencesText}
        </Typography>}
      </Grid>
      <Grid item xs={1} sm={2} />
    </Grid>
  )
}